import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import StandardizedItem from "../../entity/insurance/StandardizedItem";

const SERVICE = "service-insurance";
const ENTITY = "standardized_items";

export default function () {
    const {findAllBy} = useApi();
    const state = useSelector;
    const newInstance = data => new StandardizedItem(data);

    return {
        findAllByWorkId(workId) {
            return {
                select() {
                    const all = state(state => state.api?.insurance?.[ENTITY]);

                    if (isNull(all)) return null;

                    return all.filter(si => !isNull(si) && si.getWorkId() == workId);
                },
                exec() {
                    findAllBy(SERVICE, ENTITY, "work_id", workId, newInstance, "application");
                }
            }
        }
    }
}
